import React from 'react';
import ListItem from 'components/ListItem';
import {
    SprayWaterTotal,
    SprayEntityIds,
    SprayApplicationRate,
    SprayEquipmentSetId
} from 'services/sprayEvents/types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { makeSelectWaterTotal } from './selectors';

export interface OwnProps {
    entityIds: SprayEntityIds;
    waterRate: SprayApplicationRate;
    equipmentSetId: SprayEquipmentSetId;
    applicationRate: SprayApplicationRate;
    needHalfCalculation: boolean;
}

export interface ConnectedProps {
    waterTotal: SprayWaterTotal;
}

type Props = OwnProps & ConnectedProps;

export class SummaryApplicationWaterTotalListItemComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { waterTotal } = this.props;

        return <ListItem description="Water total" value={`${waterTotal} L`} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    waterTotal: makeSelectWaterTotal()
});

export default connect(mapStateToProps)(
    SummaryApplicationWaterTotalListItemComponent
);
